import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import createEntityElementForPricing from 'src/editor/pages/website-pricing/create-entity-element-for-website-pricing'
import createSettingsForPricing from 'src/editor/pages/website-pricing/create-settings-for-website-pricing'
import BlogPage from './blog/BlogPage'
import createEntityElementForBlog from './blog/createEntityElementForBlog'
import createSettingsForBlog from './blog/createSettingsForBlog'
import createEntityElementForBlogPage from './blog-page/createEntityElementForBlogPage'
import createSettingsForBlogPage from './blog-page/createSettingsForBlogPage'
import BlogPostLayoutPage from './blog-post-layout/BlogPostLayoutPage'
import BlogPost from './blogPost/BlogPost'
import createEntityElementForBlogPost from './blogPost/createEntityElementForBlogPost'
import CommonPage from './CommonPage'
import createEntityElementForContactUs from './contact-us/createEntityElementForContactUs'
import createSettingsForContactUs from './contact-us/createSettingsForContactUs'
import createCommonEntityElement from './createCommonEntityElement'
import createCommonEntitySettings from './createCommonEntitySettings'
import CustomLoginPage from './custom-login/CustomLoginPage'
import createEntityElementForCustomLogin from './custom-login/createEntityElementForCustomLogin'
import InlineForm from './InlineForm'
import createEntityElementForOffer from './offer/createEntityElementForOffer'
import createSettingsForOfferPage from './offer/createSettingsForOfferPage'
import PaymentPage from './PaymentPage'
import { RemotePopup } from './remote-popup'
import SalesPage from './SalesPage'
import createEntityElementForSales from './sales/createEntityElementForSales'
import createSettingsForSales from './sales/createSettingsForSales'
import createEntityElementForUpsell from './upsell/createEntityElementForUpsell'
import createSettingsForUpsell from './upsell/createSettingsForUpsell'
import createEntityElementForWebinarRegistration from './webinar-registration-page/createEntityElementForWebinarRegistration'
import createSettingsForWebinarRegistration from './webinar-registration-page/createSettingsForWebinarRegistration'
import createEntityElementForWebinarSession from './webinar-session/createEntityElementForWebinarSession'
import createSettingsForWebinarSession from './webinar-session/createSettingsForWebinarSession'
import createEntityElementForWebinarThankYou from './webinar-thank-you/createEntityElementForWebinarThankYou'
import createSettingsForWebinarThankYou from './webinar-thank-you/createSettingsForWebinarThankYou'
import { createEntityElementForWebsite } from './website/create-entity-element-for-website'
import { CommonLibraryElementsStructuresCreator } from 'src/editor/shared/entities/common-library-elements-structures-creator'
import { WebsiteLibraryElementsStructuresCreator } from 'src/editor/pages/website/website-library-elements-structures-creator'
import { WebsiteLoginPage } from 'src/editor/pages/website/websit-login-page'
import { createEntityElementForWebsiteLogin } from 'src/editor/pages/website-login/create-entity-element-for-website-login'
import createSettingsForWebsiteLogin from 'src/editor/pages/website-login/create-settings-for-website-login'

export function createPage(type: PageTypeEnum) {
  let PageComponent: React.ComponentType<{ children: React.ReactNode }>
  let createEntityElement = createCommonEntityElement
  let createEntitySettings = createCommonEntitySettings
  let createLibraryElementStructure =
    new CommonLibraryElementsStructuresCreator().create
  switch (type) {
    case PageTypeEnum.OfferPage:
    case PageTypeEnum.OfferInner:
      createEntityElement = createEntityElementForOffer
      createEntitySettings = createSettingsForOfferPage
      PageComponent = PaymentPage
      break
    case PageTypeEnum.OfferDownSellPage:
    case PageTypeEnum.OfferUpSellPage:
      createEntityElement = createEntityElementForUpsell
      createEntitySettings = createSettingsForUpsell
      PageComponent = PaymentPage
      break
    case PageTypeEnum.SalesPage:
      createEntityElement = createEntityElementForSales
      createEntitySettings = createSettingsForSales
      PageComponent = SalesPage
      break
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogLayout:
      PageComponent = BlogPage
      createEntityElement = createEntityElementForBlog
      createEntitySettings = createSettingsForBlog
      break
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogSearch:
    case PageTypeEnum.BlogStatic:
      PageComponent = BlogPage
      createEntityElement = createEntityElementForBlogPage
      createEntitySettings = createSettingsForBlogPage
      break
    case PageTypeEnum.BlogPostBody:
      PageComponent = BlogPost
      createEntityElement = createEntityElementForBlogPost
      break
    case PageTypeEnum.Inline:
      PageComponent = InlineForm
      break
    case PageTypeEnum.Popup:
      PageComponent = RemotePopup
      break
    case PageTypeEnum.CustomLogin:
      PageComponent = CustomLoginPage
      createEntityElement = createEntityElementForCustomLogin
      break
    case PageTypeEnum.FunnelContactUs:
      PageComponent = CommonPage
      createEntityElement = createEntityElementForContactUs
      createEntitySettings = createSettingsForContactUs
      break
    case PageTypeEnum.BlogPostLayout:
      PageComponent = BlogPostLayoutPage
      createEntityElement = createEntityElementForBlog
      createEntitySettings = createSettingsForBlog
      break
    case PageTypeEnum.WebinarThankYou:
      PageComponent = CommonPage
      createEntityElement = createEntityElementForWebinarThankYou
      createEntitySettings = createSettingsForWebinarThankYou
      break
    case PageTypeEnum.WebinarSession:
      PageComponent = CommonPage
      createEntityElement = createEntityElementForWebinarSession
      createEntitySettings = createSettingsForWebinarSession
      break
    case PageTypeEnum.WebinarRegistration:
      PageComponent = CommonPage
      createEntityElement = createEntityElementForWebinarRegistration
      createEntitySettings = createSettingsForWebinarRegistration
      break
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteDefault: {
      PageComponent = CommonPage
      createEntityElement = createEntityElementForWebsite
      createEntitySettings = createCommonEntitySettings
      createLibraryElementStructure =
        new WebsiteLibraryElementsStructuresCreator().create
      break
    }
    case PageTypeEnum.WebsitePricingPage: {
      PageComponent = CommonPage
      createEntityElement = createEntityElementForPricing
      createEntitySettings = createSettingsForPricing
      break
    }
    case PageTypeEnum.WebsiteLogin:
      PageComponent = WebsiteLoginPage
      createEntityElement = createEntityElementForWebsiteLogin
      createEntitySettings = createSettingsForWebsiteLogin
      createLibraryElementStructure =
        new WebsiteLibraryElementsStructuresCreator().create
      break
    default:
      PageComponent = CommonPage
  }

  return {
    PageComponent,
    createEntityElement,
    createEntitySettings,
    createLibraryElementStructure,
  }
}
